<template>
    <div class="main-div">
        <el-row justify="end" class="headbar">
            <el-col :span="4" />
            <el-col :span="20">
                <el-form
                    :model="args"
                    class="search-form" :inline="true">
                    <el-form-item label="" prop="corp" style="width: 150px;">
                        <el-select
                            ref="corpSelect"
                            v-model="args.corp"
                            autocomplete="off"
                            placeholder="企业"
                            clearable
                            @change="load_data">
                            <el-option
                                v-for="(corp_data, i) in corp_list"
                                :key="i"
                                :label="corp_data.name"
                                :value="corp_data.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="type" style="width: 100px;">
                        <el-select
                            ref="typeSelect"
                            v-model="args.type"
                            autocomplete="off"
                            placeholder="类型"
                            clearable
                            @change="load_data">
                            <el-option
                                v-for="(type, i) in type_list"
                                :key="i"
                                :label="type.label"
                                :value="type.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="query" style="width: 250px;">
                        <el-input
                            v-model="args.query"
                            autocomplete="off"
                            placeholder=""
                            clearable
                            maxlength="32"
                            @change="load_data" />
                    </el-form-item>
                    <el-form-item style="width: 46px;">
                        <el-button
                            type="primary"
                            @click="load_data">
                            <el-icon><Search /></el-icon>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="content">
            <el-table
                ref="elTable"
                :data="data.slice((page-1)*rspp,page*rspp)"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id"
                :expand-row-keys="expand_row_keys"
                @expand-change="on_expand_change">
                <el-table-column fixed type="expand">
                    <template #default="props">
                        <div class="info-box">
                            <!-- 循环渲染标签 -->
                            <el-tag
                                v-for="tag in props.row.machines"
                                :key="tag"
                                closable
                                @close="unlink_machine(props.row, tag)">
                                {{ tag.name }}
                            </el-tag>
                            <!-- 添加 -->
                            <el-select
                                v-model="selectedTag"
                                placeholder="Please select"
                                filterable
                                @change="value => link_machine(props.row, value)">
                                <el-option
                                    v-for="item in get_available_machines(props.row)"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item" />
                            </el-select>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed type="index" align="center" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="!i"
                    :label="col.label"
                    :formatter="col.formatter"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
                <el-table-column fixed="right" label="" width="80" align="center">
                    <template #header>
                        <el-tooltip content="添加" placement="top">
                            <el-button
                                link
                                type="primary"
                                @click="add_item()">
                                <el-icon><plus /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                    <template #default="item">
                        <el-tooltip content="编辑" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="mod_item($event, item.row)">
                                <el-icon><edit /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                            <el-button
                                link
                                type="danger"
                                size="small"
                                @click="del_item($event, item.row)">
                                <el-icon><delete /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row class="pagebar">
            <el-pagination
                align="center"
                :current-page="page"
                :page-sizes="[10,20,50,999]"
                :page-size="rspp"
                layout="total, sizes, prev, pager, next, jumper"
                :total="data.length"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </el-row>
    </div>
    <DialogBox ref="DialogBox" />
</template>
<script>
import {notify} from '../../assets/js/utils.js';
import {try_catch} from '../../assets/js/async.js';
import {Search, Edit, Plus, Delete} from '@element-plus/icons-vue';
import DialogBox from './dlg-box.vue';
import UserStore from '../../stores/user.js';

export default {
    name: 'UserList',
    components: {
        Search,
        Edit,
        Plus,
        Delete,
        DialogBox,
    },
    data: function() {
        const type_list = [
            {'value': 'bigscreen', 'label': '大屏幕'},
            {'value': 'gluebox', 'label': '复合配胶'},
        ];
        const type_dict = Object.fromEntries(type_list.map(x => [x.value, x.label]));
        return {
            args: {
                corp: '',
                query: '',
            },
            expand_row_keys: [],
            corp_list: null,
            type_list,
            type_dict,
            data: [],
            page: 1, // 当前页码
            rspp: 20, // 每页的数据条数
            machines: [],
            selectedTag: null,
            tableCols: [{
                prop: 'corp_name',
                label: '企业',
                width: 150,
                align: 'center',
            },
            {
                prop: 'code',
                label: '编码',
                width: 150,
                align: 'center',
            },
            {
                prop: 'name',
                label: '名称',
                width: 200,
                align: 'center',
            },
            {
                prop: 'type',
                label: '类别',
                width: 200,
                align: 'center',
                formatter: row => this.type_dict[row.type],
            },
            {
                prop: 'state_name',
                label: '状态',
                width: 80,
                align: 'center',
            }],
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        corp_map() {
            return this.corp_list.reduce((rs, x) => { rs[x.id] = x; return rs; }, {});
        },
    },
    beforeMount() {
        this.load_data();
    },
    methods: {
        // on_expand_change(row, _children) {
        on_expand_change(row) {
            const key = row.id;
            const index = this.expand_row_keys.indexOf(key);
            if (index < 0) {
                this.expand_row_keys.push(key);
            } else {
                this.expand_row_keys.splice(index, 1);
            }
        },
        async add_item() {
            return await try_catch(async () => {
                const data = await this.$refs.DialogBox.show({
                    data: { },
                    list: this.data,
                    type_list: this.type_list,
                    corporations: this.corp_list,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async mod_item(_, row) {
            return await try_catch(async () => {
                const data = await this.$refs.DialogBox.show({
                    data: JSON.parse(JSON.stringify(row)),
                    list: this.data,
                    type_list: this.type_list,
                    corporations: this.corp_list,
                });
                console.debug(data);
                this.load_data();
            });
        },
        async del_item(_, row) {
            return await try_catch(async () => {
                await this.$confirm(`确认要删除"${row.name}"`, '删除提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });

                const url = `/admin/api/boxes/${row.id}`;
                const res = await this.axios.delete(url);
                if (res.data?.result) {
                    notify('success', '删除成功', 999);
                } else {
                    notify('error', res.data.error);
                }
                this.load_data();
            });
        },
        get_available_machines(box) {
            // console.log('Corp', this.corp_map[box.corp_id]);
            return this.corp_map[box.corp_id].machines.filter(
                m => !box.machines.map(x => x.id).includes(m.id),
            );
        },
        async link_machine(box, machine) {
            console.log('Link machine for', box, machine);
            const url = '/admin/api/box-machine/';
            const data = {corp_id: box.corp_id, box_id: box.id, machine_id: machine.id};
            const resp = await this.axios.post(
                url, data,
                {headers: {'Content-Type': 'application/json'}},
            );
            if (resp.data?.result === 'OK') {
                box.machines.push(resp.data.data);
                notify('success', '添加成功');
            } else {
                console.log(resp);
                notify('error', `${resp.data.error || resp.data.message}`);
            }
            this.selectedTag = null;
        },
        async unlink_machine(box, machine) {
            const url = '/admin/api/box-machine/';
            const params = {boxid: box.id, machid: machine.id};
            const rs = await this.axios.delete(url, {params});
            if (rs.data.result === 1) {
                notify('success', '删除成功');
                const index = box.machines.indexOf(machine);
                if (index !== -1) {
                    box.machines.splice(index, 1);
                }
            } else {
                notify('error', rs.error ?? rs.message);
            }
        },
        async load_data() {
            await try_catch(async () => {
                const url = `/admin/api/boxes/`;
                const args = [
                    ['q', this.args.query],
                    ['t', this.args.type],
                    ['c', this.args.corp],
                ].reduce((rs, [k, v]) => {
                    if (v) rs[k] = v;
                    return rs;
                }, {});
                const [corp_list, res] = await Promise.all([
                    this.load_corps(),
                    this.axios.get(url, {params: args})]);
                if (res.data.code && res.data.code !== 200) {
                    notify('error', `加载列表失败 ${res.data.code}`);
                    console.error(res);
                    return;
                }
                const data = res.data.data;
                console.log(data);
                data.forEach(item => {
                    item.state_name = [0, '0'].indexOf(item.state) >= 0 ? '冻结' : '活跃';
                    item.corp_name = corp_list.find(corp => corp.id === item.corp_id)?.name;
                });
                this.data.length = 0;
                this.data.push(...data);
            });
        },
        async load_corps() {
            if (!this.corp_list) {
                const url = `/admin/api/corporations/`;
                const res = await this.axios.get(url, {params: {wm: true}});
                this.corp_list = res.data.data;
            }
            return this.corp_list;
        },
        handleSizeChange(val) {
            this.page = 1;
            this.rspp = val;
        },
        // 当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            this.page = val;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    height: 100px;
    flex-grow: 1;
}
.search-form {
    text-align: right;
}
.search-form>.el-form-item {
    margin-bottom: 0;
    margin-right: 0;
    width: 150px;
}
</style>
